import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Locale
import messages from '../../../locale/messages';

//image
import { TickSvgIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';
import s from './Payment.css';
class HouseRules extends Component {
  static propTypes = {
    houseRules: PropTypes.array.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  render() {
    const { hostDisplayName, houseRules } = this.props;

    return (
      <div>
        <h3 className={cx(s.h3, s.space4)}>
          <span>{hostDisplayName}'s <FormattedMessage {...messages.houseRules} /></span>
        </h3>
        {
          houseRules.map((item, index) => {
            if (item?.listsettings?.isEnable === "1") {
              return (
                <div className={cx(s.houseRules)} key={index}>
                  <TickSvgIcon className={s.houseRulesTick} />
                  <span className={cx(s.itemWidth, 'reviewTextRTL')}>{item.listsettings && item.listsettings.itemName}</span>
                </div>
              )
            }
          })
        }
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(HouseRules));

